import type { CultureCode } from '@agency';
import type { EnvironmentName } from '../../../../environments/environment.types';

export type CostaExtraEnvironment = EnvironmentName;

type CostaExtraOrigins = Record<Exclude<CostaExtraEnvironment, 'local'>, string>;

const LOCAL_COSTA_EXTRA_ORIGIN = 'https://training.costaextra.it';
const COSTA_EXTRA_ORIGINS: Record<CultureCode, CostaExtraOrigins> = {
  'it-IT': {
    preview: 'https://training.costaextra.it',
    production: 'https://www.costaextra.it',
  },
  'fr-FR': {
    preview: 'https://training.costaextra.fr',
    production: 'https://www.costaextra.fr',
  },
  'es-ES': {
    preview: 'https://training.costaextra.es',
    production: 'https://www.costaextra.es',
  },
  'pt-PT': {
    preview: 'https://training.costaextra.pt',
    production: 'https://www.costaextra.pt',
  },
  'de-DE': {
    preview: 'https://training.costaextra.de',
    production: 'https://www.costaextra.de',
  },
  'de-AT': {
    preview: 'https://training.costaextra.at',
    production: 'https://www.costaextra.at',
  },
  'it-CH': {
    preview: 'https://training.costaextra.ch',
    production: 'https://www.costaextra.ch',
  },
  'en-BZ': {
    preview: 'https://training.int.costaextra.com',
    production: 'https://int.costaextra.com',
  },
  'nl-BE': {
    preview: 'https://training.costaextra.be',
    production: 'https://www.costaextra.be',
  },
  'en-GB': {
    preview: 'https://training.costaextra.uk',
    production: 'https://www.costaextra.uk',
  },
  'en-US': {
    preview: 'https://training.booking.costaextra.com',
    production: 'https://booking.costaextra.com',
  },
  'es-AR': {
    preview: 'https://training.booking.costaextra.com.ar',
    production: 'https://booking.costaextra.com.ar',
  },
  'es-MX': {
    preview: 'https://training.booking.costaextra.com.mx',
    production: 'https://booking.costaextra.com.mx',
  },
  'pt-BR': {
    preview: 'https://training.booking.costaextra.com.br',
    production: 'https://booking.costaextra.com.br',
  },
  'fr-BE': {
    preview: 'https://training.costaextra.be',
    production: 'https://www.costaextra.be',
  },
  'en-PH': {
    preview: 'https://training.int.costaextra.com',
    production: 'https://int.costaextra.com',
  },
};

export function resolveCostaExtraOrigin(environment: string, culture: CultureCode): string {
  switch (environment) {
    case 'local':
      return LOCAL_COSTA_EXTRA_ORIGIN;
    case 'preview':
    case 'production':
      return COSTA_EXTRA_ORIGINS[culture][environment];
    default:
      throw new Error(`Unsupported Costa Extra environment: ${environment}`);
  }
}

export function resolveCostaExtraBaseUrl(environment: string, culture: CultureCode): string {
  return `${resolveCostaExtraOrigin(environment, culture)}/CostaClick/${culture}/_vti_bin/CostaClickNew/UIServices`;
}
